/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-shadow */
import { IGlobalSettingHjex } from '@/utils/interfaces/iGlobalSetting'
import { GetterTree } from 'vuex'
import { IRootState } from './model'

const getters: GetterTree<IRootState, IRootState> = {
  reloadTable(state) {
    return state.hjpTable.reloadTable
  },
  reloadDataList(state) {
    return state.hjpDataList.reloadData
  },
  getSearchField(state) {
    return state.fieldSearch
  },
}

export default getters
